import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { PaginationBar } from "../PaginationBar";
import { fmtTL } from "./CollapsibleSection";

const METHOD_LABELS = { safe: "Kasa", kasa: "Kasa", bank: "Banka", banka: "Banka", temlik: "Temlik", cash: "Nakit" };

const DetailRow = ({ item, testIdPrefix }) => (
  <div className="flex items-start justify-between gap-3 py-2 border-b last:border-b-0" data-testid={`${testIdPrefix}-row-${item.id}`}>
    <div className="min-w-0">
      <p className="text-sm font-medium text-gray-900 truncate">{item.title || "-"}</p>
      {item.description && <p className="text-xs text-gray-600 break-words">{item.description}</p>}
      <p className="text-xs text-gray-400">
        {item.date ? new Date(item.date).toLocaleString("tr-TR") : ""}
        {item.payment_method && item.payment_method !== "-" && ` • ${METHOD_LABELS[item.payment_method] || item.payment_method}`}
        {item.user && item.user !== "-" && ` • ${item.user}`}
      </p>
    </div>
    <span className="text-sm font-semibold whitespace-nowrap">{fmtTL(item.amount)}</span>
  </div>
);

export const PeriodDetailList = ({ api, sessionToken, category, period, perPage = 20, testIdPrefix }) => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, total_amount: 0 });
  const [loading, setLoading] = useState(true);

  const load = async (p) => {
    setLoading(true);
    try {
      const res = await axios.get(`${api}/dashboard/period-details`, {
        params: { session_token: sessionToken, category, period, limit: perPage, skip: (p - 1) * perPage },
      });
      setData(res.data);
      setPage(p);
    } catch (e) {
      console.error("Dönem detayları alınamadı:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(1); }, [category, period]);

  return (
    <div data-testid={testIdPrefix}>
      <div className="flex items-center justify-between text-sm mb-2">
        <span className="text-gray-600" data-testid={`${testIdPrefix}-count`}>{data.total} işlem</span>
        <span className="font-bold" data-testid={`${testIdPrefix}-total`}>Toplam: {fmtTL(data.total_amount)}</span>
      </div>
      {loading && data.items.length === 0 ? (
        <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-gray-400" /></div>
      ) : data.items.length === 0 ? (
        <p className="text-center text-sm text-gray-500 py-6" data-testid={`${testIdPrefix}-empty`}>Bu dönemde işlem yok</p>
      ) : (
        <div className={loading ? "opacity-60" : ""}>
          {data.items.map((item) => <DetailRow key={item.id} item={item} testIdPrefix={testIdPrefix} />)}
        </div>
      )}
      <PaginationBar page={page} total={data.total} perPage={perPage} onPageChange={load} loading={loading} label="işlem" testIdPrefix={`${testIdPrefix}-pagination`} />
    </div>
  );
};
